import { HAS_PARENT_APP } from './consts';
import { publishMessageToParentApp } from './utils';

const copyTextToClipboardFn = (text: string) => {
  return `
    navigator.clipboard.writeText('${text}');
  `;
};

export const copyTextToClipboard = (text: string) => {
  if (!HAS_PARENT_APP) {
    Function(copyTextToClipboardFn(text))();
    return;
  }

  publishMessageToParentApp(copyTextToClipboardFn(text));
};
